import React, { useState, useEffect, useRef } from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import '../App.css'
import '../layouts/Header.css'

import { BsSearch } from 'react-icons/bs'
import { BiChevronDown } from 'react-icons/bi'
import { IoStar } from 'react-icons/io5'

import { Link } from 'react-router-dom'
import Axios from 'axios'
import TopBarProgress from 'react-topbar-progress-indicator'

import { CheckUserLogin } from '../sessions/CheckUserLoggin'
import { API_URL } from '../config'

const url = `${API_URL}/apps/kscanner`

export default function Header() {
  const dropdownRef = useRef(null)
  const searchRef = useRef(null)

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [queryResults, setQueryResults] = useState([])
  const [searchOpen, setSearchOpen] = useState(false)
  const [customer, setCustomer] = useState({ customername: '', email: '', phone: '' })

  const customerId = localStorage.getItem('customerid')

  const displayName = customer.customername || localStorage.getItem('customername') || 'Guest'

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }

      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchOpen(false)
      }
    }

    Axios.get(`${url}/webservices.php?query=CUSTOMERDETAILS&accountid=${customerId}`, {
      withCredentials: true,
    })
      .then((response) => {
        setCustomer({
          customername: response.data.customername || '',
          email: response.data.email || '',
          phone: response.data.phone || '',
        })
      })
      .catch((error) => {
        console.error('Error fetching customer details:', error)
      })

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleLogout = async () => {
    try {
      await fetch(`${url}/logout.php`, {
        method: 'GET',
        credentials: 'include',
      })

      localStorage.clear()
      window.location.href = '/login'
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  const handleSearch = async (event) => {
    const searchVal = event.target.value

    setSearch(searchVal)

    if (!searchVal.trim()) {
      setQueryResults([])
      setSearchOpen(false)
      return
    }

    setSearchOpen(true)

    try {
      const response = await Axios.get(
        `${url}/webservices.php?query=SEARCHEVENTS&search=${encodeURIComponent(searchVal)}`,
        { withCredentials: true },
      )

      if (response.data.val === 0 || response.data.val === '0') {
        setQueryResults([])
      } else {
        setQueryResults(Array.isArray(response.data) ? response.data : [])
      }
    } catch (error) {
      console.error('Search request failed:', error)
      setQueryResults([])
    }
  }

  const date = new Date()
  const fulldate = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`

  const closeDropdown = () => setDropdownOpen(false)

  return (
    <>
      <header className="kx-header">
        <CheckUserLogin />

        <div className="kx-header__inner">
          {/* BRAND */}
          <Link to="/customerdashboard" className="kx-header__brand">
            <span className="kx-header__brand-name">
              karamale<span>.</span>
            </span>
          </Link>

          {/* SEARCH */}
          <div className="kx-header__search" ref={searchRef}>
            <div
              className={`kx-header__search-box ${searchOpen ? 'kx-header__search-box--active' : ''}`}
            >
              <BsSearch className="kx-header__search-icon" size={16} />

              <input
                type="text"
                placeholder="Search events..."
                value={search}
                onChange={handleSearch}
                onFocus={() => {
                  if (search.trim()) {
                    setSearchOpen(true)
                  }
                }}
                autoComplete="off"
              />

              {search && (
                <button
                  type="button"
                  className="kx-header__search-clear"
                  onClick={() => {
                    setSearch('')
                    setQueryResults([])
                    setSearchOpen(false)
                  }}
                >
                  ×
                </button>
              )}
            </div>

            {searchOpen && (
              <div className="kx-header__search-results">
                {queryResults.length < 1 ? (
                  <div className="kx-header__no-results">
                    <span className="kx-header__no-results-title">No events found</span>
                    <span>Try searching for another event.</span>
                  </div>
                ) : (
                  queryResults.map((item, index) => {
                    if (item.indexid >= 1) {
                      return null
                    }

                    const posterUri = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.poster}`

                    const eventName =
                      item.event_name && item.event_name.length > 27
                        ? `${item.event_name.substr(0, 27)}...`
                        : item.event_name

                    const businessName =
                      item.businessname && item.businessname.length > 30
                        ? `${item.businessname.substr(0, 30)}...`
                        : item.businessname

                    return (
                      <Link
                        key={index}
                        to={{
                          pathname: `/event/${item.eventid}/tickets`,
                          state: {
                            fromHome: true,
                            eventid: item.eventid,
                            eventDate: item.event_day,
                            fulldate,
                            customerid: customerId,
                            posterUri,
                            accountid: customerId,
                            accounttype: localStorage.getItem('accounttype'),
                            customername: displayName,
                            email: customer.email,
                            phone: customer.phone,
                            venue: item.event_location,
                            description: item.event_des,
                            businessid: item.businessid,
                            poster: item.poster,
                            eventname: item.eventname,
                            eventday: item.eventday,
                            starttime: item.start_time,
                            endtime: item.finish_time,
                            previousPage: window.location.pathname.replace(/\\|\//g, ''),
                            campaignStatus: 'running',
                            category: '',
                          },
                        }}
                        className="kx-header__search-result"
                        onClick={() => setSearchOpen(false)}
                      >
                        <div className="kx-header__result-row">
                          <div className="kx-header__result-poster">
                            {item.poster ? (
                              <img src={posterUri} alt="" />
                            ) : (
                              <div className="kx-header__result-poster-empty" />
                            )}
                          </div>

                          <div className="kx-header__result-info">
                            <div className="kx-header__result-title">
                              <span>{eventName}</span>

                              {item.is_sponsorship == 1 && (
                                <span className="kx-header__sponsored">
                                  <IoStar size={11} />
                                </span>
                              )}
                            </div>

                            <div className="kx-header__result-host">
                              <span>Host:</span> {businessName}
                            </div>
                          </div>

                          <span className="kx-header__result-arrow">→</span>
                        </div>
                      </Link>
                    )
                  })
                )}
              </div>
            )}
          </div>

          {/* RIGHT SIDE */}
          <div className="kx-header__right">
            {/* <nav className="kx-header__guest-nav">
              <Link to="/customerdashboard">Dashboard</Link>
              <Link to="/">Events</Link>
            </nav> */}

            <div className="kx-header__account" ref={dropdownRef}>
              <button
                type="button"
                className="kx-header__account-trigger"
                onClick={() => setDropdownOpen((current) => !current)}
              >
                <span className="kx-header__avatar">{displayName.charAt(0).toUpperCase()}</span>

                <span className="kx-header__account-copy">
                  <span className="kx-header__account-name">
                    {displayName.length > 20 ? `${displayName.slice(0, 20)}...` : displayName}
                  </span>
                  <span className="kx-header__account-type">Attendee</span>
                </span>

                <BiChevronDown
                  className={`kx-header__account-arrow ${
                    dropdownOpen ? 'kx-header__account-arrow--open' : ''
                  }`}
                  size={20}
                />
              </button>

              {dropdownOpen && (
                <div className="kx-header__dropdown">
                  <div className="kx-header__dropdown-heading">ACCOUNT</div>

                  <Link to="/customerdashboard" onClick={closeDropdown}>
                    <span>Dashboard</span>
                    <span>→</span>
                  </Link>

                  <Link to="/" onClick={closeDropdown}>
                    <span>Events</span>
                    <span>→</span>
                  </Link>

                  <Link to="/profile" onClick={closeDropdown}>
                    <span>My Account</span>
                    <span>→</span>
                  </Link>

                  <Link to="/feedback" onClick={closeDropdown}>
                    <span>Feedback</span>
                    <span>→</span>
                  </Link>

                  <Link
                    to={{ pathname: '/changepassword', state: { credentials: 'password' } }}
                    onClick={closeDropdown}
                  >
                    <span>Change Password</span>
                    <span>→</span>
                  </Link>

                  <div className="kx-header__dropdown-divider" />

                  <button
                    type="button"
                    onClick={handleLogout}
                    className="kx-header__dropdown-logout"
                  >
                    <span>Log out</span>
                    <span>↗</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      <div className="kx-header-spacer" />
    </>
  )
}

TopBarProgress.config({
  barColors: {
    0: 'red',
    '1.0': 'red',
  },
  shadowBlur: 0,
})
